import { render } from "./PublicFigures.vue?vue&type=template&id=70069c0d&scoped=true"
import script from "./PublicFigures.vue?vue&type=script&lang=js"
export * from "./PublicFigures.vue?vue&type=script&lang=js"

import "./PublicFigures.vue?vue&type=style&index=0&id=70069c0d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70069c0d"]])

export default __exports__